/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }

  const handleSeeInStoreClick = (e) => {
    try {
      const productTitle = $('.product__title').text();
      localStorage.setItem('seeInStoreTitle', productTitle);

      const productSku = window.ShopifyAnalytics.meta.product.variants[0].sku;
      localStorage.setItem('seeInStoreSku', productSku);

      const productLink = document.location.href;
      localStorage.setItem('seeInStoreLink', productLink);

      const productImage = $('.product-single__media img').attr('src');
      localStorage.setItem('seeInStoreImg', productImage);

      window.location.href = `/pages/see-in-store?sku=${productSku}`;
    } catch (err) {
      console.error('error caught in handleSeeInStoreClick() in custom.js, err: ', err);
    }
  }

  const populateSeeInStore = () => {
    try {
      const productTitle = localStorage.getItem('seeInStoreTitle');
      const productSku = localStorage.getItem('seeInStoreSku');
      const productLink = localStorage.getItem('seeInStoreLink');
      const productImage = localStorage.getItem('seeInStoreImg');

      $('.see-in-store-product-selected').text(productTitle);
      $('.see-in-store-product a .product-name').text(productTitle);
      $('.see-in-store-product a').attr('href', productLink);
      $('.see-in-store-product-sku').text(productSku);
      $('.see-in-store-product img').attr('src', productImage);
    } catch (err) {
      console.error('error caught in populateSeeInStore() in custom.js, err: ', err);
    }
  }

  const handleEngravingClick = (e) => {

    if ($(e.target).is(':checked')) {
      $('.engraving-textbox-container').removeClass('titan-hide');

      if (!$('.engraving-textbox-container input').val().length) {
        $('.product__submit__buttons #AddToCart--template--19982760313114__main').prop('disabled', true);
      }
    } else {
      $('.engraving-textbox-container').addClass('titan-hide');
      $('.product__submit__buttons #AddToCart--template--19982760313114__main').prop('disabled', false);
    }
  }

  const handleEngravingText = async (e) => {
    const cart = await getCart();

    if (e.target.value.length) {
      $('.product__submit__buttons #AddToCart--template--19982760313114__main').prop('disabled', false);
    } else {
      $('.product__submit__buttons #AddToCart--template--19982760313114__main').prop('disabled', true);
    }
  }

  const addLineItemProperty = async (variantId, properties, associatedSku) => {
    const currentCart = await getCart();

    const ringInCart = currentCart.items.find((product) => {
      return product.sku === associatedSku
    });

    const updatedProperties = {
      ...ringInCart.properties,
      ...properties
    }

    await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        properties: updatedProperties
      })
    }).catch((err) => {
      console.error('error caught in change cart item, err: ', err);
    });
  }

  const populateJmPlans = async () => {
    if ($('.cart-drawer__items .cart-jm-3yr').length) {
      $('.cart-drawer__items .cart-jm-3yr').on('click', async function () {

        if ($(this).is(':checked')) {
          const uuid = uuidv4();
          addItem($(this).attr('data-vid'), 1, { associatedSku: $(this).attr('data-associated-sku'), uuid: uuid });

          await new Promise(r => setTimeout(r, 500));

          addLineItemProperty($(this).attr('data-base-vid'), { uuid: uuid }, $(this).attr('data-associated-sku'));
        } else {
          const currentCart = await getCart();

          const matchingProduct = currentCart.items.find((item) => {
            return item.sku === $(this).attr('data-sku');
          });

          if (matchingProduct) {
            await changeCartItem($(this).attr('data-vid'));
          } else {
            console.error('matching product not found in removing JM item! matchingProduct: ', matchingProduct);
          }
        }
      });
    }

    if ($('.cart-drawer__items .cart-jm-lifetime').length) {
      $('.cart-drawer__items .cart-jm-lifetime').on('click', async function () {

        if ($(this).is(':checked')) {
          const uuid = uuidv4();
          addItem($(this).attr('data-vid'), 1, { associatedSku: $(this).attr('data-associated-sku'), uuid: uuid });

          await new Promise(r => setTimeout(r, 500));

          addLineItemProperty($(this).attr('data-base-vid'), { uuid: uuid }, $(this).attr('data-associated-sku'));
        } else {
          const currentCart = await getCart();

          const matchingProduct = currentCart.items.find((item) => {
            return item.sku === $(this).attr('data-sku');
          });

          if (matchingProduct) {
            await changeCartItem($(this).attr('data-vid'));
          } else {
            console.error('matching product not found in removing JM item! matchingProduct: ', matchingProduct);
          }
        }
      });
    }

    if ($('.jm-tooltip-text').length) {
      $('.jm-tooltip-text').on('click', function (e) {
        if ($(this).find('.care-plan-tooltip').css('display') !== 'block') {
          $(this).find('.care-plan-tooltip').show();
        }
      });

      $('body').on('click', function () {
        $('.care-plan-tooltip').each(function () {
          if ($(this).is('visible')) {
            $(this).hide();
          }
        });
      });
    }
  }

  const handleAddToCart = async (e) => {
    // e.preventDefault();

    const engravingText = $('.engraving-textbox-container input').val();

    if ($('.engraving-checkbox-container input').is(':checked') && engravingText.length) {
      const productSku = window.ShopifyAnalytics.meta.product.variants[0].sku;

      setTimeout(() => {
        addItem(46828919685402, 1, { text: engravingText, associatedSku: productSku });

        document.dispatchEvent(new CustomEvent('cart:build', {
          detail: {
            cart: cart
          }
        }));

        getCart();
      }, "1000");
    }

    setTimeout(function () {
      populateJmPlans();
    }, '1000');
  }

  const getCart = async () => {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
      return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }

  const addItem = async (variantId, quantity, properties = {}) => {
    
    await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: properties
      })
    }).then((res) => {
      return res.json();
    })
  }

  const changeCartItem = async (variantId) => {
    await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    }).catch((err) => {
      console.error('error caught in change cart item, err: ', err);
    });
  }

  const hideRingSizes = () => {
    if (ShopifyAnalytics.meta.product.variants[0].name.includes('(size')) {
      let ringSize = ShopifyAnalytics.meta.product.variants[0].name.split('(size ')[1];
      ringSize = ringSize.split(')')[0];

      $('#ring-size-selector option').each(function () {
        if ($(this).attr('value') !== ringSize) {
          $(this).remove();
        }
      });

      $('#ring-size-selector').val(ringSize);
    } else if ($('#ring-size-selector').attr('data-ring-size')) {
      let dataRingSize = $('#ring-size-selector').attr('data-ring-size');

      if (dataRingSize.includes('.5')) {
        dataRingSize = dataRingSize.split('.')[0] + ' 1/2';
      } else if (dataRingSize.includes('.')) {
        dataRingSize = dataRingSize.split('.')[0];
      }

      $('#ring-size-selector option').each(function (i) {
        if ($(this).attr('value') !== dataRingSize) {
          $(this).remove();
        }
      });

      $('#ring-size-selector').val(dataRingSize);
    } else if (ShopifyAnalytics.meta.product.vendor.includes('JOHN HARDY')) {
      if ($('#hidden-gender-metafield').text() === 'Womens') {
        $('#ring-size-selector option[value="4 1/2"]').remove();
        $('#ring-size-selector option[value="5 1/2"]').remove();
        $('#ring-size-selector option[value="6 1/2"]').remove();
        $('#ring-size-selector option[value="7 1/2"]').remove();
        $('#ring-size-selector option[value="8 1/2"]').remove();
        $('#ring-size-selector option[value="9"]').remove();
        $('#ring-size-selector option[value="9 1/2"]').remove();
        $('#ring-size-selector option[value="10"]').remove();
        $('#ring-size-selector option[value="10 1/2"]').remove();
        $('#ring-size-selector option[value="11"]').remove();
        $('#ring-size-selector option[value="11 1/2"]').remove();
        $('#ring-size-selector option[value="12"]').remove();
        $('#ring-size-selector').val('5');
      } else {
        $('#ring-size-selector option[value="4 1/2"]').remove(); 
        $('#ring-size-selector option[value="5"]').remove();
        $('#ring-size-selector option[value="5 1/2"]').remove();
        $('#ring-size-selector option[value="6"]').remove();
        $('#ring-size-selector option[value="6 1/2"]').remove();
        $('#ring-size-selector option[value="7"]').remove();
        $('#ring-size-selector option[value="7 1/2"]').remove();
        $('#ring-size-selector option[value="8"]').remove();
        $('#ring-size-selector option[value="8 1/2"]').remove();
        $('#ring-size-selector option[value="9 1/2"]').remove();
        $('#ring-size-selector option[value="10 1/2"]').remove();
        $('#ring-size-selector option[value="11 1/2"]').remove();
        $('#ring-size-selector').val('9');
      }
    } else if (ShopifyAnalytics.meta.product.variants[0].sku.includes('RMOM')) {
      $('#ring-size-selector option[value="4 1/2"]').remove(); 
      $('#ring-size-selector option[value="10 1/2"]').remove();
      $('#ring-size-selector option[value="11"]').remove();
      $('#ring-size-selector option[value="11 1/2"]').remove();
      $('#ring-size-selector option[value="12"]').remove();
    } else if ($('#hidden-gender-metafield').text() === 'Womens') {
      $('#ring-size-selector option[value="4 1/2"]').remove(); 
      $('#ring-size-selector option[value="5"]').remove();
      $('#ring-size-selector option[value="5 1/2"]').remove();
      $('#ring-size-selector option[value="8 1/2"]').remove();
      $('#ring-size-selector option[value="9"]').remove();
      $('#ring-size-selector option[value="9 1/2"]').remove();
      $('#ring-size-selector option[value="10"]').remove();
      $('#ring-size-selector option[value="10 1/2"]').remove();
      $('#ring-size-selector option[value="11"]').remove();
      $('#ring-size-selector option[value="11 1/2"]').remove();
      $('#ring-size-selector option[value="12"]').remove();
      $('#ring-size-selector').val('6');
    } else if ($('#hidden-gender-metafield').text() === 'Mens') {
      $('#ring-size-selector option[value="4 1/2"]').remove(); 
      $('#ring-size-selector option[value="5"]').remove();
      $('#ring-size-selector option[value="5 1/2"]').remove();
      $('#ring-size-selector option[value="6"]').remove();
      $('#ring-size-selector option[value="6 1/2"]').remove();
      $('#ring-size-selector option[value="7"]').remove();
      $('#ring-size-selector option[value="7 1/2"]').remove();
      $('#ring-size-selector option[value="8"]').remove();
      $('#ring-size-selector option[value="8 1/2"]').remove();
      $('#ring-size-selector').val('9');
    } else {
      $('#ring-size-selector option[value="4 1/2"]').remove(); 
      $('#ring-size-selector option[value="5"]').remove();
      $('#ring-size-selector option[value="5 1/2"]').remove();
      $('#ring-size-selector option[value="8 1/2"]').remove();
      $('#ring-size-selector option[value="9"]').remove();
      $('#ring-size-selector option[value="9 1/2"]').remove();
      $('#ring-size-selector option[value="10"]').remove();
      $('#ring-size-selector option[value="10 1/2"]').remove();
      $('#ring-size-selector option[value="11"]').remove();
      $('#ring-size-selector option[value="11 1/2"]').remove();
      $('#ring-size-selector option[value="12"]').remove();
      $('#ring-size-selector').val('6');
    }
  }

  const hideCustomEngraving = () => {

    if ($('.collection__products').length) {
      $('.collection__products .product-grid-item__info').each(function () {
        const title = $(this).find('.product-grid-item__title').text();

        if (title === 'Custom Engraving') {
          $(this).hide();
        }
      })
    }
  }

  const hideEmptySpecifications = () => {
    try {
      $('.product__accordion__content.specifications p').each(function (index) {
        if (!$(this).text().split(': ')[1].length) {
          $(this).addClass('titan-hide');
        }

        if ($(this).text().split(':')[0] === 'Case Depth Rating') {
          if (ShopifyAnalytics.meta.product.type !== 'WATCHES & CLOCKS') {
            $(this).addClass('titan-hide');
          }
        }

        if ($(this).text().split(':')[0] === 'Case Size (mm)') {
          if (ShopifyAnalytics.meta.product.type !== 'WATCHES & CLOCKS') {
            $(this).addClass('titan-hide');
          }
        }
      });
    } catch (err) {
      console.error('error caught in hideEmptySpecifications(), err: ', err);
    }
  }

  const hideDuplicateTryOn = () => {
    try {
      $('.picupmedia_container').each(function () {
        if ($(this).find('button').length > 1) {
          const dupeBtn = $(this).find('button')[1];
          $(dupeBtn).hide();
        }
      });
    } catch (err) {
      console.error('error caught in hideDuplicateTryOn, err: ', err);
    }
  }

  const moveIcons = () => {
    $('.product__icon__row').insertBefore('.product__submit__holder');
  }

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (document.location.href.includes('/products')) {
        $('.product-see-in-store button').on('click', handleSeeInStoreClick);
        $('.engraving-checkbox-container input').on('click', handleEngravingClick);
        $('.engraving-textbox-container input').on('change', handleEngravingText);
        $('.product-add-to-cart button').on('click', handleAddToCart);
        hideEmptySpecifications();
        moveIcons();
        if ($('#ring-size-selector').length) {
          hideRingSizes();
        }
        if (document.location.href.includes('/search') || document.location.href.includes('/collections')) {
          hideCustomEngraving();
        }
      }

      if ($('.cart__toggle--has-items').length) {
        $('.cart__toggle--has-items').on('click', populateJmPlans);
      }

      if (document.location.href.includes('/pages/see-in-store')) {
        populateSeeInStore();
      }

      setTimeout(() => {
        if ($('.picupmedia_container').length) {
          hideDuplicateTryOn();
        }
      }, "300");
    } catch (err) {
      console.error('error caught in dom ready in custom.js, err: ', err);
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
